<template>
  <header class="mbsHeader-wapper">
    <div class="mbsHeader-left">
        <img src="https://3vj-fe.3vjia.com/fe-common/image/logo/logo-white.png" class="mbsHeader-logo" onclick="location.href='/'" >
        <div class="mbsHeader-line"></div>
        <div class="mbsHeader-sys">开放平台</div>
        <slot name="left">
            <ul class="mbsHeader-menu">
                <li
                    v-for="(item,index) in menuList"
                    @click="handleMenuItemClick(item)"
                    :class="{'mbsHeader-menuItem--selected': curKey == item.key}"
                    class="mbsHeader-menuItem"
                    :key="index">{{item.name}}</li>
            </ul>
        </slot>
    </div>
    <div class="mbsHeader-right">
        <slot name="right">
          <img class="mbsHeader-avatar" :src="avatar" alt="">
          <ul class="drop-down user-list data-guide-usercenter-list">
            <li class="user-list__item">
              <a :href="ucenterLink" target="_blank">个人中心</a>
            </li>
            <li class="user-list__item">
              <a :href="adminLink" target="_blank">企业后台</a>
            </li>
            <li class="user-list__item exit" @click="exit">
              退出登录
            </li>
          </ul>
        </slot>
    </div>
  </header>
</template>

<script>
const defaultLogoImg = require('./logo.png');

const defaultAvatar = 'https://3vj-fe.3vjia.com/common/images/default-avatar.png?x-oss-process=image/resize,m_fill,h_36,w_0';
export default {
  name: 'mbsHeader',
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
    logoImg: {
      default: defaultLogoImg,
    },
    avatar: {
      type: String,
      default: defaultAvatar,
    },
  },
  data() {
    return {
      curKey: '',
      ucenterLink: `${process.env.VUE_APP_3VJIA_DOMAIN_NAME}/ucenter/`,
      adminLink: `${process.env.VUE_APP_ADMIN_WEB_DOMAIN}/`,
    };
  },
  methods: {
    handleMenuItemClick(item) {
      this.curKey = item.key;
      this.$emit('itemClick', item);
    },
    exit() {
      window.location.href = `${process.env.VUE_APP_GRAPH_URL}/logout?redirect_uri=${encodeURIComponent(
        window.location.href,
      )}`;
    },
  },
};
</script>

<style lang="less">
.mbsHeader{
    &-wapper {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        height: 100%;
        background-color: #1B1B1C;;
    }
    &-left {
        display: flex;
        align-items: center;
        height: 100%;
    }
    &-right {
      display: flex;
      align-items: center;
      height: 100%;
      &:hover {
        .user-list {
          transform: scale(1);
        }
      }
      .user-list {
        width: 140px;
        li,
        a {
          display: block;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #178fff;
          }
        }
        .user-list__item {
          padding: 12px 0;
          padding-left: 24px;
          line-height: 14px;
          &:hover {
            background: #e7f4ff;
          }
          &.user-item__intro {
            &:hover {
              background: #fff;
            }
            h4 {
              margin-bottom: 0;
              font-weight: 700;
              font-size: 14px;
              line-height: 14px;
            }
            span {
              display: inline-block;
              margin-bottom: 0;
              padding-top: 10px;
              width: 100%;
              color: rgba(153, 153, 153, 1);
              font-size: 12px;
              &:hover {
                color: rgba(153, 153, 153, 1);
              }
            }
          }
          &.border-bottom {
            border-bottom: 1px solid rgba(0, 0, 0, 0.14);
          }
        }
      }
    }
    &-logo {
        display: inline-block;
        height: 40px;
        cursor: pointer;
    }
    &-line {
      display: inline-block;
      margin-left: 8px;
      width: 1px;
      height: 12px;
      background: rgba(255, 255, 255, 0.2);
    }
    &-sys {
      display: inline-block;
      margin-left: 8px;
      width: 64px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22px;
    }
    &-menu {
        margin: 0;
        margin-left: 40px;
        padding: 0;
        display: inline-block;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: -0.29px;
        text-align: center;
    }
    &-menuItem {
        position: relative;
        margin-right: 40px;
        display: inline-block;
        transform:scale(1);
        // transition: .2s;
        opacity: 0.8;
        list-style: none;
        cursor: pointer;
        &:hover {
            color: #178FFF;
        }
        &--selected {
            transform:scale(1.2);
            // font-size: 20px;
            letter-spacing: -0.36px;
            &::after {
                position: absolute;
                bottom: -8px;
                left: 0;
                right: 0;
                content: '';
                height: 1px;
                background-color: #178FFF;
                border: 1px solid #178FFF;
                border-radius: 20px;
            }
        }
    }
   &-avatar{
       height: 36px;
       border-radius: 100%;
       cursor: pointer;
   }
}
.drop-down {
  position: absolute;
  top: 55px;
  right: 0;
  font-size: 14px;
  line-height: 30px;
  padding: 10px 0;
  color: #666;
  border-radius: 4px;
  transform-origin: 50% 0;
  transform: scale(0);
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  text-align: left;
  z-index: 10000;
  &::before {
    content: '';
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    position: absolute;
    top: -6px;
    left: 95px;
  }
}

</style>
